module.exports = __webpack_public_path__ + "assets/italic-mobile.d0a1cf01.svg";